/**
 * Contrato comum das regras de tabuleiro.
 *
 * O servidor e a unica autoridade: o cliente manda intencao ("peao para e4")
 * e quem decide se aquilo e legal e este modulo. Nenhuma implementacao aqui
 * faz I/O, le relogio ou conhece dinheiro — isso mantem as regras
 * testaveis de forma exaustiva e deterministica.
 */

/** Assento na partida. 0 joga primeiro. */
export type Seat = 0 | 1;

/** Lance em notacao propria de cada jogo. Opaco para o resto do sistema. */
export type Move = string;

export type Outcome =
  | { kind: 'WIN'; seat: Seat; reason: string }
  | { kind: 'DRAW'; reason: string };

export interface GameRules<S> {
  readonly id: 'TIC_TAC_TOE' | 'CHECKERS' | 'CHESS';

  /** Posicao inicial. */
  initial(): S;

  /** De quem e a vez. */
  turn(state: S): Seat;

  /** Todos os lances legais na posicao. Vazio significa fim de jogo. */
  legalMoves(state: S): Move[];

  /**
   * Aplica um lance. Lanca IllegalMoveError se o lance nao estiver em
   * legalMoves. Nunca muta o estado recebido.
   */
  apply(state: S, move: Move): S;

  /** Resultado, ou null se a partida continua. */
  outcome(state: S): Outcome | null;

  /** Representacao textual estavel, para log de auditoria e reconstrucao. */
  serialize(state: S): string;

  /** Reconstroi o estado a partir da forma serializada. */
  deserialize(text: string): S;
}

export class IllegalMoveError extends Error {
  readonly code = 'ILLEGAL_MOVE';
  readonly move: Move;

  // Campos declarados explicitamente: o strip de tipos do Node nao aceita
  // parameter properties (`constructor(readonly move: Move)`).
  constructor(move: Move, reason: string) {
    super(`lance ilegal ${JSON.stringify(move)}: ${reason}`);
    this.name = 'IllegalMoveError';
    this.move = move;
  }
}

/** O adversario do assento dado. */
export function opponent(seat: Seat): Seat {
  return seat === 0 ? 1 : 0;
}
